import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
import "../css/Contact.css";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t, i18n } = useTranslation();
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    phone: "",
    message: "",
    agree: false,
  });

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_APP_URL}/companies`,
          {
            headers: {
              "X-Platform": process.env.REACT_APP_X_PLATFORM,
              "API-Key": process.env.REACT_APP_API_KEY,
              "X-API-Version": process.env.REACT_APP_X_API_VERSION,
            },
            withCredentials: true,
          }
        );
        setCompanyData(response.data.data[0]);
      } catch (error) {
        console.error("Error fetching company data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanyData();
  }, [i18n.language]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
  };

  if (loading) {
    return (
      <Container className="contact-container">
        <div className="contact-shimmer-container">
          <div className="contact-shimmer-info">
            <div className="contact-shimmer-title"></div>
            <div
              className="contact-shimmer-line"
              style={{ width: "80%" }}
            ></div>
            <div
              className="contact-shimmer-line"
              style={{ width: "90%" }}
            ></div>
            <div
              className="contact-shimmer-line"
              style={{ width: "70%" }}
            ></div>
          </div>
          <div className="contact-shimmer-form">
            <div className="contact-shimmer-title"></div>
            <div className="contact-shimmer-line"></div>
            <div className="contact-shimmer-line"></div>
            <div
              className="contact-shimmer-line"
              style={{ width: "80%" }}
            ></div>
            <div
              className="contact-shimmer-line"
              style={{ width: "60%" }}
            ></div>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container className="contact-container">
      <Row className="contact-section">
        <Col md={5} className="contact-info">
          <h2>{t("getInTouch")}</h2>
          {companyData && (
            <>
              <p>
                <FaMapMarkerAlt size={35} /> {companyData.address}
              </p>
              <p>
                <FaEnvelope /> {companyData.email}
              </p>
              <p>
                <FaPhone /> {companyData.phone}
              </p>
              <div className="social-icons">
                <a
                  href={companyData.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook color="white" />
                </a>
                <a
                  href={companyData.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram color="white" />
                </a>
                <a
                  href={companyData.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTiktok color="white" />
                </a>
                <a
                  href={companyData.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube color="white" />
                </a>
              </div>
              <div
                className="map-container"
                dangerouslySetInnerHTML={{ __html: companyData.latlong }}
              />
            </>
          )}
        </Col>

        <Col md={7} className="contact-form">
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mt-3">
              <Form.Label>{t("email")}</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder={t("yourEmail")}
              />
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Label>{t("phoneNumber")}</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder={t("yourNumber")}
              />
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Label>{t("message")}</Form.Label>
              <Form.Control
                as="textarea"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                required
                placeholder={t("placeholderMessage")}
              />
            </Form.Group>

            <Button type="submit" className="send-message-btn mt-3">
              {t("sendMessage")}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
